import React, { useMemo } from 'react';
import { DrawerRoute, TIDrawerRouteProps } from './DrawerRoute';
import DrawerOnCloseContextProvider from './DrawerOnCloseContextProvider';

export const DrawerRoutes: React.FC = () => {
  const drawerRoutes = useMemo<TIDrawerRouteProps[]>(() => [], []);

  return (
    <>
      {drawerRoutes.map((route, index) => (
        <DrawerOnCloseContextProvider key={`drawer-context-${index}`}>
          <DrawerRoute key={route.path as string} {...route} />
        </DrawerOnCloseContextProvider>
      ))}
    </>
  );
};
